import React from 'react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetHeaderCloseButton,
} from 'components/ModalSheet'
import { observer } from 'mobx-react'
import ScopeChangeRequestResolveDialogViewModel from './ScopeChangeRequestResolveDialogViewModel'
import { JobClosedNotificationBar } from 'admin/scope-change-requests/components/ScopeChangeRequestDetailsPanel/DetailsFooter'
import { useBrandingSettings } from 'hooks/branding'
import Button from 'components/Button'
import { ToggleGroup, ToggleItem } from 'components/ToggleGroup'
import styles from './ScopeChangeRequestResolveDialogViewModel.sass'

interface ScopeChangeRequestResolveDialogProps {
  vm: ScopeChangeRequestResolveDialogViewModel
}

export default observer(function ScopeChangeRequestResolveDialog({
  vm,
}: ScopeChangeRequestResolveDialogProps) {
  const { corporateMode } = useBrandingSettings()

  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader>
        <div className={styles.closeButtonContainer}>
          <ModalSheetHeaderCloseButton dataTest="scope-change-request-close-resolve-dialog" />
        </div>
      </ModalSheetHeader>
      <ModalSheetContent>
        <ModalSheetContentBlock>
          {!corporateMode && (
            <ModalSheetContentIllustration
              src={require('assets/images/img_send-prompt-message.svg')}
              alt="Resolve"
            />
          )}
          <ModalSheetContentTitle>
            Resolve job scope discrepancy
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Discuss resolutions with client{' '}
            <span className={styles.collaboratorName}>
              {vm.scopeChangeRequest.jobClient?.member.displayName}
            </span>
            , and select the agreed upon action to resolve this change request.
          </ModalSheetContentDescription>
          <ToggleGroup stretch>
            <ToggleItem
              toggled={vm.resolveAction === 'accept'}
              onChange={() => vm.setAction('accept')}
              disabled={vm.isJobClosed}
              dataTest="scope-change-request-accept"
            >
              Accept on behalf of the client
            </ToggleItem>
            <ToggleItem
              toggled={vm.resolveAction === 'reject'}
              onChange={() => vm.setAction('reject')}
              dataTest="scope-change-request-reject"
            >
              Reject on behalf of the client
            </ToggleItem>
          </ToggleGroup>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <JobClosedNotificationBar showing={vm.isJobClosed} />
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button onClick={vm.close} type="default">
            Close
          </Button>
          <Button
            onClick={vm.resolve}
            type="primary"
            disabled={vm.resolveAction === 'none' || vm.resolve.pending}
            dataTest="scope-change-request-resolve-client"
            loading={vm.resolve.pending}
          >
            Resolve
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
